module.exports = __webpack_public_path__ + "static/media/mask.39b69d42.svg";